import { getSupabase } from '../../lib/supabase/client'
import { normalizeError } from '../../lib/errors'
import type { Notification, NotificationPreferences } from '../../types/domain'

export async function listNotifications(): Promise<Notification[]> {
  const { data, error } = await getSupabase()
    .schema('api')
    .rpc('list_notifications', { p_before: null, p_limit: 40 })
  if (error) throw normalizeError(error)
  return ((data ?? []) as Record<string, unknown>[]).map((row) => ({
    id: String(row.id),
    kind: String(row.kind),
    title: String(row.title),
    body: String(row.body),
    actionUrl: row.action_url ? String(row.action_url) : null,
    entityType: row.entity_type ? String(row.entity_type) : null,
    entityId: row.entity_id ? String(row.entity_id) : null,
    readAt: row.read_at ? String(row.read_at) : null,
    createdAt: String(row.created_at),
  }))
}

export async function markNotificationsRead(ids?: string[]) {
  const { data, error } = await getSupabase()
    .schema('api')
    .rpc('mark_notifications_read', { p_notification_ids: ids ?? null })
  if (error) throw normalizeError(error)
  return Number(data ?? 0)
}

export async function getNotificationPreferences(): Promise<NotificationPreferences> {
  const { data, error } = await getSupabase().schema('api').rpc('get_notification_preferences')
  if (error) throw normalizeError(error)
  const row = data as Record<string, unknown>
  return {
    emailContactRequests: Boolean(row.email_contact_requests),
    emailEventReminders: Boolean(row.email_event_reminders),
    emailEventUpdates: Boolean(row.email_event_updates),
    emailAnnouncements: Boolean(row.email_announcements),
  }
}

export async function updateNotificationPreferences(value: NotificationPreferences) {
  const { data, error } = await getSupabase()
    .schema('api')
    .rpc('update_notification_preferences', { p_payload: value })
  if (error) throw normalizeError(error)
  return data
}
